import * as React from 'react';
import { Column } from "react-table";
import Table from "../../components/table/Table";
import { CLIENT_ROUTE, API_ROUTE, CLIENT_TITLE } from "./constants";
import TableIndicator from "../../components/common/TableStatus";
import type { IContact } from "./types";
import Page from "../../components/layout/Page";
import { useListPage } from "../../hooks";
import RowActions from "../../components/table/RowActions";

interface IContactRecord extends Pick<IContact, '_id' | 'label' | 'text' | 'isActive'>{
    actions: unknown;
}

const CategoryList = () => {

    const { handleInteraction, records, paginationState } = useListPage<IContactRecord>({
        clientRoute: CLIENT_ROUTE,
        apiRoute: API_ROUTE
    })

    const columns: Column<IContactRecord>[] =  [
        {
            Header: 'Түлхүүр үг',
            accessor: 'label'
        },
        {
            Header: 'Текст',
            accessor: 'text'
        },
        {
            Header: 'Төлөв',
            accessor: 'isActive',
            Cell: ({ value }) => {
                return <TableIndicator active={value}/>;
            },
            width: 1
        },
        {
            Header: '',
            accessor: 'actions',
            Cell: (table) => {
                return (
                    <RowActions id={table.row.original._id} clientRoute={CLIENT_ROUTE} />
                )
            }
        },
    ];

    return (
        <Page>
            <Page.Header title={CLIENT_TITLE}/>
            <Page.Body>
                <Table
                    columns={columns}
                    data={records}
                    totalPages={paginationState.totalPage}
                    onInteraction={handleInteraction}
                />
            </Page.Body>
        </Page>
    )
};

export default CategoryList;